/**
 * Bank Relationships (FSD Part 3 3.2.1, R063 register + concentration, R064 counterparty limit,
 * R060 charges against tariff; follow-up #71).
 *
 * The wiring packet spreads `TREASURY_BANK_RELATIONSHIP_ROUTES` into the router and adds the nav
 * item described by `TREASURY_BANK_RELATIONSHIP_NAV` to section s-3.2.1 (near
 * `treasury-concentration`). The detail path sits under the register path, so the one nav item
 * covers both (segment-aware prefix).
 *
 * Both routes are gated on `cash.bank_relationship.read`, which every read route declares; each
 * write action is further gated on `cash.bank_relationship.manage` inside the screens.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BANK_RELATIONSHIP_PERMISSIONS } from '@/modules/treasury/bank-relationships/permissions'

export const TREASURY_BANK_RELATIONSHIPS_PATH = '/treasury/bank-relationships'

export function bankRelationshipPath(id: number): string {
  return `${TREASURY_BANK_RELATIONSHIPS_PATH}/${id}`
}

/** For the wiring packet: the nav item to add (p03-treasury.ts, s-3.2.1). */
export const TREASURY_BANK_RELATIONSHIP_NAV = {
  id: 'treasury-bank-relationships',
  section: 's-3.2.1',
  code: 'R063',
  to: TREASURY_BANK_RELATIONSHIPS_PATH,
  labelKey: 'treasury.bankRelationships.nav.label',
  descriptionKey: 'treasury.bankRelationships.nav.description',
  permission: BANK_RELATIONSHIP_PERMISSIONS.read,
} as const

export const TREASURY_BANK_RELATIONSHIP_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_BANK_RELATIONSHIPS_PATH,
    name: 'treasury-bank-relationships',
    component: () => import('@/modules/treasury/bank-relationships/BankRelationshipsView.vue'),
    meta: {
      titleKey: 'treasury.bankRelationships.routeTitles.register',
      permission: BANK_RELATIONSHIP_PERMISSIONS.read,
    },
  },
  {
    path: `${TREASURY_BANK_RELATIONSHIPS_PATH}/:id(\\d+)`,
    name: 'treasury-bank-relationship',
    component: () => import('@/modules/treasury/bank-relationships/BankRelationshipView.vue'),
    meta: {
      titleKey: 'treasury.bankRelationships.routeTitles.detail',
      permission: BANK_RELATIONSHIP_PERMISSIONS.read,
    },
  },
]
